import axios from 'axios';

const list = (data) => axios.get('/custom/honor/list', data);
const save = (data) => axios.post('/custom/honor/saveOrUpdate', data);
const del = (data) => axios.post('/custom/honor/delete', data); //delete

export default {
  list,
  save,
  del,
}


